import Head from 'next/head';
import Dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { Container, Box } from '@mui/material';

import Header from 'components/Shared/Header';

import ScarcityVacancyComponent from 'components/Shared/ScarcityVacancy';

import DynamicFaqComponent from 'components/DynamicFaqComponent';

import { abroadFaq } from 'mocks/abroadFaq';
import { DefaultMenuNav } from 'mocks/menuNav';

const Footer = Dynamic(() => import('components/Footer'), { ssr: true });

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.string.isRequired,
  showFaq: PropTypes.bool,
  showFooterCountries: PropTypes.bool,
};

Layout.defaultProps = {
  showFaq: false,
  showFooterCountries: true,
};

export default function Layout({
  children,
  maxWidth,
  showFaq,
  showFooterCountries,
}) {
  return (
    <Box bgcolor="background.paper">
      <Head>
        <meta
          content="Fluencypass - Seu intercâmbio sem taxa de agência"
          key="title"
          property="og:title"
        />
        <meta
          content="O jeito mais fácil para fazer seu intercâmbio. Seu intercâmbio com o preço direto da escola sem as taxas das agências!"
          key="description"
          property="og:description"
        />
      </Head>

      <Header menuNavHeader={DefaultMenuNav} menuNavSideMenu={DefaultMenuNav} />

      <ScarcityVacancyComponent />

      <Box my={2}>
        <Container maxWidth={maxWidth}>{children}</Container>
      </Box>

      {showFaq && (
        <Box sx={{ bgcolor: 'background.secondary.main', mt: 8, pt: 1, pb: 8 }}>
          <Container maxWidth="lg">
            <DynamicFaqComponent
              dynamicFaqText="Perguntas frequentes"
              showButton={false}
              dynamicFaqTopics={abroadFaq}
            />
          </Container>
        </Box>
      )}

      <Footer maxWidth={maxWidth} showCountries={showFooterCountries} />
    </Box>
  );
}
